import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

const routes = [
  {
    path: "/index",
    component: () => import("@/views/index/index.vue"),
    meta: {
      public: true,
      title: "深海的小站",
    },
  },
  {
    path: "/",
    redirect: "/index",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, form, next) => {
  document.title = to.meta.title;
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
